import { Download } from "@mui/icons-material";
import { Divider, Grid2, IconButton, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router";
import Logo from "../logo";
import { ProjectData } from "../NavigationData/ProjectData";

export function Header({ project }: { project?: ProjectData }) {
  let navigate = useNavigate();

  let downloadLink = project && `/images/${project.name}/${project.download_link}.pdf`;

  return (
    <Stack direction={"row"} sx={{ flex: "0 0 auto", maxHeight: "75px", backgroundColor: "black", padding: "8px" }}>
      <IconButton
        onClick={() => navigate("/")}
        style={{
          borderRadius: "1rem",
          marginRight: ".5rem",
          marginTop: ".25rem",
        }}
      >
        <Logo style={{ width: "2rem", stroke: "white", strokeWidth: "1rem" }} />
      </IconButton>
      <Divider orientation="vertical" flexItem sx={{ marginRight: ".75rem" }} />
      <Grid2 container flexGrow={1} spacing={{ xs: 0, sm: 2 }} sx={{ marginTop: ".25rem" }}>
        <Grid2 size={{ xs: 12, sm: "auto" }}>
          <Typography
            variant="h6"
            component="div"
            sx={{
              display: "flex",
              fontFamily: "orator-std",
              letterSpacing: ".45rem",
              // marginBottom: "-.25rem",
              fontSize: { xs: "1rem", sm: "1.25rem" },
              alignItems: "center",
              height: "100%",
            }}
          >
            STEVEN
          </Typography>
        </Grid2>
        <Grid2 size={{ xs: 12, sm: "auto" }}>
          <Typography
            variant="h6"
            component="div"
            sx={{
              fontFamily: "orator-std",
              letterSpacing: ".28rem",
              fontSize: { xs: "1rem", sm: "1.25rem" },
              display: "flex",
              height: "100%",
              alignItems: "center",
            }}
          >
            GRULLÓN
          </Typography>
        </Grid2>
      </Grid2>
      {downloadLink && (
        <IconButton href={downloadLink} target="_blank" color="inherit">
          <Download />
        </IconButton>
      )}
    </Stack>
  );
}
